import { RESET_TEMP_STATE } from '../../../constants/tempActionNames';

function resetTempStateSuccess() {
  return {
    type: RESET_TEMP_STATE,
    payload: [],
  };
}

export function resetTempStateAction() {
  return resetTempStateSuccess();
}

export default {
  resetTempStateAction,
};
